import React, { useState, useContext, useEffect } from 'react';
import '../styles/message.css';
import filterContext from '../context/filters/filterContext';
// import { log } from '@craco/craco/lib/logger';
import { Button, Checkbox, Image, Input, Modal, Tooltip } from 'antd';
import { RiShareForwardFill } from 'react-icons/ri';
// import { apiBaseUrl } from 'utils/config';
import { MdPictureAsPdf } from 'react-icons/md';
import { BsCheckAll, BsDownload } from 'react-icons/bs';
import { DownOutlined } from '@ant-design/icons';
import { BsCheck } from 'react-icons/bs';
import { SlFlag } from 'react-icons/sl';
import readTick from './read.png';
import unreadTick from './check.png';
import doubleCheck from './double-check.png';
import moment from 'moment';
import doc from './doctype.png';
import { FaDownload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import { IoIosArrowDown } from 'react-icons/io';
import { data } from 'autoprefixer';
import Groupinformation from './Groupinformation';
function Message({
	msg,
	time,
	isLink,
	img,
	sent,
	media,
	msgId,
	isRedFlag,
	sender,
	senderId,
	senderName,
	prevId,
	prevTime,
	mentions,
	isPdf,
	refMsg,
	isForwarded,
	forwardedTag,
	forwardedMsgId,
	deliveryStatus,
	readBy,
	remark,
	create,
}) {
	const {
		fetchConversation,
		usersOfParticularGroup,
		conversationdata,
		selectedMsgs,
		setSelectedMsgs,
		forwardCheckbox,
		setForwardCheckbox,
		setReplyId,
		replyId,
		replyMsg,
		setReplyMsg,
		selectedReceivedMsgs,
		setSelectedReceivedMsgs,
		selectedRedFlagMsgs,
		setSelectedRedFlagMsgs,
		activeDropdownMsgId,
		setActiveDropdownMsgId,
		selectedMsgsForForward,
		setSelectedMsgsForForward,
		selectedMsgsForDelete,
		setSelectedMsgsForDelete,
		getMsg,
		readbyNames,
		readByArray,
		displayedUsersOfGroup,
	} = useContext(filterContext);
	const [readByModel, setReadByModel] = useState(false);
	const [fullscreenVisible, setFullscreenVisible] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');
	const [showDropdown, setShowDropdown] = useState(false);
	const [isRedFlagged, setIsRedFlagged] = useState(isRedFlag);
	const [isDeleted, setIsDeleted] = useState(false);
	const [isUnsend, setIsUnsend] = useState(false);
	const [showInfoModal, setShowInfoModal] = useState(false);
	const [deliveryStatusData, setDeliveryStatusData] = useState([]);
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const [remarkInput, setRemarkInput] = useState('');
	const [showDeliveryStatusModal, setShowDeliveryStatusModal] = useState(false);

	const userSelector = state => state.user;
	const user = useSelector(userSelector);

	const markAsRedFlag = () => {
		// If the message is already red-flagged, show the delivery status modal
		if (isRedFlagged) {
			setShowDeliveryStatusModal(true);
		} else {
			// For marking as Red Flag, clear the remarkInput state
			setRemarkInput('');

			const requestBody = { id: msgId, remark: '' };

			fetch(`${apiBaseUrl}/chats/toggleMessageRedFlag`, {
				method: 'POST',
				body: JSON.stringify(requestBody),
				headers: {
					'Content-Type': 'application/json',
					authorization: `Token ${window.localStorage.getItem('token')}`,
				},
			})
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						setIsRedFlagged(true);
						fetchConversation();
					} else {
						console.error('Error marking message as red flag:', data.error);
					}
				})
				.catch(error => {
					console.error('Error marking message as red flag:', error);
				});
		}
		setShowDropdown(false);
	};

	// Function to handle the submission of the remark and toggle the modal
	const handleRemarkSubmission = () => {
		if (remarkInput.trim() === '') {
			// Perform validation to ensure the remark is not empty
			alert('Please provide a remark.');
			return;
		}

		const requestBody = { id: msgId, remark: remarkInput.trim() };

		fetch(`${apiBaseUrl}/chats/toggleMessageRedFlag`, {
			method: 'POST',
			body: JSON.stringify(requestBody),
			headers: {
				'Content-Type': 'application/json',
				authorization: `Token ${window.localStorage.getItem('token')}`,
			},
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					setIsRedFlagged(false);
					// setRemarkInput(''); // Clear the remarkInput after successful submission
					renderFlagTooltip();
					fetchConversation();
					setShowDeliveryStatusModal(false); // Close the modal
				} else {
					console.error('Error removing red flag:', data.error);
				}
			})
			.catch(error => {
				console.error('Error removing red flag:', error);
			});
	};

	const replyToMessage = messageId => {
		const regexForBold = /(?<=\s|^|\*)\*([^\n]+?)\*(?=\s|$|\*)/g;
		const regexForItalics = /(?<=\s|^|\*)\_([^\n]+?)\_(?=\s|$|\*)/g;

		let formattedText = msg;

		formattedText = formattedText.replace(regexForBold, '$1');
		formattedText = formattedText.replace(regexForItalics, '$1');
		setReplyId(messageId);
		// console.log(msg);
		setReplyMsg({
			name: senderName,
			text: formattedText,
		});
	};
	const toggleInfoModal = () => {
		if (showInfoModal) {
			// If the modal is already open, close it
			setShowInfoModal(false);
		} else {
			// Fetch delivery status data from the server
			fetchDeliveryStatusData();
		}
	};

	const fetchDeliveryStatusData = () => {
		// Make an API call to get the delivery status data
		// console.log('Calledx');
		fetch(`${apiBaseUrl}/chats/getDeliveryStatus?messageId=${msgId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Token ${window.localStorage.getItem('token')}`,
			},
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					// Set the delivery status data in the state
					setDeliveryStatusData(data.deliveredStatus);
					// Show the modal
					setShowInfoModal(true);
				} else {
					console.error('Error fetching delivery status data:', data.error);
				}
			})
			.catch(error => {
				console.error('Error fetching delivery status data:', error);
			});
	};

	const renderReferenceMessage = () => {
		if (refMsg) {
			return (
				<div style={{ marginRight: '0.75rem' }}>
					<div
						className={sender ? 'reference-message-right' : 'reference-message-left'}
					>
						<div className="sender-name">
							{refMsg.sender._id == senderId ? 'You' : refMsg.sender.name}
						</div>
						<div className="reference-message-text">{refMsg.text}</div>
					</div>
				</div>
			);
		}
		return null;
	};

	const openFullScreen = imageUrl => {
		// console.log('select');
		setSelectedImage(imageUrl);
		setFullscreenVisible(true);
	};

	const closeFullScreen = () => {
		setSelectedImage('');
		setFullscreenVisible(false);
	};

	// const handleCaretClick = event => {
	// 	event.stopPropagation();
	// 	setShowDropdown(true);
	// };

	// const handleDropdownBlur = () => {
	// 	setShowDropdown(false);
	// };
	const handleCaretClick = (event, messageId) => {
		event.stopPropagation();
		// console.log(messageId, activeDropdownMsgId);
		if (activeDropdownMsgId === messageId) {
			setShowDropdown(false);
			setActiveDropdownMsgId(null); // Close the dropdown if it's already open
		} else {
			setShowDropdown(true);
			setActiveDropdownMsgId(messageId); // Open the dropdown for the clicked message
		}
		readbyNames(msgId);
	};

	// Function to close dropdown when a click occurs outside of it
	const handleClickOutside = event => {
		if (showDropdown && !event.target.closest('.dropdown')) {
			setShowDropdown(false);
			setActiveDropdownMsgId(null);
		}
	};

	useEffect(() => {
		// Add event listener on component mount
		window.addEventListener('click', handleClickOutside);

		// Remove event listener on component unmount
		return () => {
			window.removeEventListener('click', handleClickOutside);
		};
	}, [showDropdown]);

	const handleMsgSelect = (
		userId,
		refMsgId,
		isSender,
		isRedFlagTrue,
		isMsgForwarded,
		msgText
	) => {
		// if (selectedMsgs.includes(userId)) {
		// 	setSelectedMsgs(selectedMsgs.filter(id => id !== userId));
		// 	setSelectedReceivedMsgs(selectedReceivedMsgs.filter(id => id !== userId));
		// 	setSelectedRedFlagMsgs(selectedRedFlagMsgs.filter(id => id !== userId));
		// } else {
		// 	setSelectedMsgs([...selectedMsgs, userId]);
		// 	if (isSender == false) {
		// 		setSelectedReceivedMsgs([...selectedReceivedMsgs, userId]);
		// 	}
		// 	if (
		// 		(isRedFlagTrue == true && isRedFlagged == true) ||
		// 		isRedFlagged == true
		// 	) {
		// 		setSelectedRedFlagMsgs([...selectedRedFlagMsgs, userId]);
		// 	}
		// }
		if (isMsgForwarded) {
			if (
				selectedMsgsForForward.includes(refMsgId) &&
				selectedMsgsForDelete.includes(userId)
			) {
				setSelectedMsgsForForward(
					selectedMsgsForForward.filter(id => id !== refMsgId)
				);
				setSelectedMsgsForDelete(selectedMsgsForDelete.filter(id => id !== userId));
				setSelectedReceivedMsgs(selectedReceivedMsgs.filter(id => id !== userId));
				setSelectedRedFlagMsgs(selectedRedFlagMsgs.filter(id => id !== userId));
			} else {
				setSelectedMsgsForForward([...selectedMsgsForForward, refMsgId]);
				setSelectedMsgsForDelete([...selectedMsgsForDelete, userId]);
				if (isSender == false || msgText == '🚫 This message was deleted.') {
					setSelectedReceivedMsgs([...selectedReceivedMsgs, userId]);
				}
				if (
					(isRedFlagTrue == true && isRedFlagged == true) ||
					isRedFlagged == true
				) {
					setSelectedRedFlagMsgs([...selectedRedFlagMsgs, userId]);
				}
			}
		} else {
			console.log(userId);
			if (
				selectedMsgsForForward.includes(userId) &&
				selectedMsgsForDelete.includes(userId)
			) {
				setSelectedMsgsForForward(
					selectedMsgsForForward.filter(id => id !== userId)
				);
				setSelectedMsgsForDelete(selectedMsgsForDelete.filter(id => id !== userId));
				setSelectedReceivedMsgs(selectedReceivedMsgs.filter(id => id !== userId));
				setSelectedRedFlagMsgs(selectedRedFlagMsgs.filter(id => id !== userId));
			} else {
				setSelectedMsgsForForward([...selectedMsgsForForward, userId]);
				setSelectedMsgsForDelete([...selectedMsgsForDelete, userId]);
				if (isSender == false || msgText == '🚫 This message was deleted.') {
					setSelectedReceivedMsgs([...selectedReceivedMsgs, userId]);
				}
				if (
					(isRedFlagTrue == true && isRedFlagged == true) ||
					isRedFlagged == true
				) {
					setSelectedRedFlagMsgs([...selectedRedFlagMsgs, userId]);
				}
			}
		}
	};

	const formatMessage = () => {
		const regexForBold = /(?<=\s|^|\*)\*([^\n]+?)\*(?=\s|$|\*)/g;
		const regexForItalics = /(?<=\s|^|\*)\_([^\n]+?)\_(?=\s|$|\*)/g;
		const regexForMentions = /(@[\w-]+)/g;

		let formattedText = msg;

		formattedText = formattedText.replace(
			regexForBold,
			'<span class="bold-msg">$1</span>'
		);
		formattedText = formattedText.replace(
			regexForItalics,
			'<span class="italic-msg">$1</span>'
		);

		if (mentions && mentions.length > 0) {
			formattedText = formattedText.replace(regexForMentions, match => {
				const mention = mentions.find(mention => {
					if (`@${mention.username}` === match || `@${mention.name}` === match) {
						return true;
					}
				});
				if (mention) {
					return `<span class="mention">${match}</span>`;
				}
				return match;
			});
		}

		formattedText = formattedText.replace(/\n/g, '<br />');

		return (
			<p dangerouslySetInnerHTML={{ __html: formattedText }} className="txt" />
		);
	};

	//check for blue tick

	const isAllReadByGroup = () => {
		if (readBy && usersOfParticularGroup) {
			return readBy.length === usersOfParticularGroup.length;
		}
		return false;
	};

	let isAllPending = false;
	let isAllDelivered = false;
	if (deliveryStatus != undefined && deliveryStatus.length != 0) {
		isAllPending = deliveryStatus.every(item => item.status === 'pending');
		isAllDelivered = deliveryStatus.every(item => item.status === 'delivered');
	}
	// Function to render tick mark based on overall status
	const renderTickMark = () => {
		if (isAllPending) {
			return <img src={unreadTick} className="tickimg" />;
		} else if (isAllDelivered) {
			return isAllReadByGroup() ? (
				<img src={doubleCheck} className="tickimg" />
			) : (
				<img src={readTick} className="tickimg" />
			);
		} else {
			return <img src={unreadTick} className="tickimg" />;
		}
	};

	const renderFlagTooltip = () => {
		if ((remark || remarkInput) && isRedFlagged == false) {
			return (
				<Tooltip title={remark ? remark : remarkInput}>
					<SlFlag
						color="white"
						fontSize="0.7em"
						style={{ margin: '4px', opacity: '0.5' }}
					/>
				</Tooltip>
			);
		}
		return null;
	};

	const formatMessageTime = time => {
		return moment(create)
			.locale('en-in')
			.format('h:mm A');
	};

	const getUserName = userId => {
		const user = usersOfParticularGroup.find(user => user.user._id === userId);
		if (user) {
			return user.user.name;
		}
		return '';
	};

	const isLastMessage = () => {
		return (
			msgId === getMsg[0]?._id &&
			!(msgId === getMsg[0]._id && msgId === getMsg[getMsg.length - 1]._id)
		);
	};

	const messageDate = () => {
		const currentDate = moment();
		const yesterdayDate = moment().subtract(1, 'day');
		if (moment(create).isSame(currentDate, 'day')) {
			return 'Today';
		} else if (moment(create).isSame(yesterdayDate, 'day')) {
			return 'Yesterday';
		} else {
			return moment(create).format('DD/MM/YYYY');
		}
	};

	return (
		<div>
			{moment(prevTime).isSame(moment(create), 'day') == false && (
				<p className="msg-date-info">{messageDate()}</p>
			)}

			<div
				className={`${selectedMsgsForDelete.includes(msgId) ? 'selected' : ''}`}
				onClick={() => {
					if (forwardCheckbox) {
						handleMsgSelect(
							msgId,
							forwardedMsgId,
							sender,
							isRedFlag,
							isForwarded,
							msg
						);
					}
				}}
				style={{
					display: 'flex',
					backgroundColor: selectedMsgsForDelete.includes(msgId)
						? 'rgba(50,73,64,0.7)'
						: 'transparent',
					cursor: forwardCheckbox ? 'pointer' : 'default',
					border: selectedMsgsForDelete.includes(msgId)
						? '0.5px solid transparent'
						: '',
					borderRadius: selectedMsgsForDelete.includes(msgId) ? '5px' : '',
				}}
			>
				{forwardCheckbox === true && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Checkbox
							checked={selectedMsgsForDelete.includes(msgId)}
							onChange={() =>
								handleMsgSelect(
									msgId,
									forwardedMsgId,
									sender,
									isRedFlag,
									isForwarded,
									msg
								)
							}
							className="rounded-checkbox"
							style={{ height: '15px', width: '15px', margin: '0 1.25rem' }}
						/>
					</div>
				)}
				<div
					style={{
						paddingLeft: `${senderId == prevId ? '2.5rem' : '0'}`,
						display: 'flex',
					}}
				>
					{usersOfParticularGroup.map(user => {
						if (user?.user?._id == senderId && sender == false && senderId != prevId) {
							return (
								<img
									src={
										user.user.dp === ''
											? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
											: user.user.dp
									}
									alt=""
									style={{
										height: '30px',
										width: '30px',
										borderRadius: '50%',
										backgroundColor: 'white',
										marginRight: '10px',
										marginTop: `${
											moment(prevTime).isSame(moment(create), 'day') == false
												? '0'
												: senderId != prevId
												? '10px'
												: '3px'
										}`,
									}}
								/>
							);
						}
					})}
				</div>
				{/* Message container */}
				<div
					id={msgId}
					className={`message-container ${
						!sender ? 'received-msg' : 'sent-msg'
					} img-msg ${isRedFlagged ? 'red-flag' : ''}`}
					style={{
						marginTop: `${
							moment(prevTime).isSame(moment(create), 'day') == false
								? '0'
								: senderId != prevId
								? '10px'
								: '3px'
						}`,
					}}
				>
					{senderId != prevId && sender == false && (
						<b
							style={{
								color: '#7381FF',
								marginTop: '0',
								paddingRight: '30px',
							}}
						>
							{senderName}
						</b>
					)}
					{forwardedTag && (
						<div style={{ color: '#8696A0', marginRight: '1rem' }}>
							<RiShareForwardFill />{' '}
							<span style={{ fontStyle: 'italic' }}>Forwarded</span>
						</div>
					)}
					{renderReferenceMessage()}
					{/* Image message */}
					{media ? (
						<div
							style={{
								positon: 'relative',
								maxWidth: '410px',
								wordBreak: 'break-word',
							}}
						>
							<div
								className="image-container image-msg"
								style={{ width: '100%', marginRight: '10px' }}
							>
								{media.map((image, index) => {
									const urlParts = image.url.split('.');
									const extension = urlParts[urlParts.length - 1].toLowerCase();

									const nameparts = image.url.split('/');
									const nameoffile = nameparts[nameparts.length - 1];
									if (
										extension === 'pdf' ||
										extension === 'xls' ||
										extension === 'csv' ||
										extension === 'plain' ||
										extension === 'rtf' ||
										extension === 'msword' ||
										extension === "xlsx" ||
										extension === "xls" ||
										extension === "pptx" ||
										extension === "ppt"
									) {
										return (
											<>
												<a href={`${image.url}`} style={{ textDecoration: 'none' }}>
													<div
														className={`message-container ${
															sender ? 'sent-msg' : 'received-msg'
														}`}
														style={{ cursor: 'pointer', marginRight: '0' }}
													>
														<div style={{ padding: '5px' }}>
															{/* <GrDocumentUpdate
																size={30}
																style={{ color: 'white', margin: '5px' }}
															/> */}
															<img src={doc} style={{ width: '9%', paddingRight: '5px' }} />
															<span style={{ color: 'white', margin: '5px' }}>
																{nameoffile}
															</span>
															<span>
																<BsDownload
																	size={15}
																	style={{ color: 'white', margin: '5px' }}
																/>
															</span>
														</div>
													</div>
												</a>
											</>
										);
									} else {
										return (
											<>
												<img
													key={index}
													src={image.url}
													alt={`Image ${index}`}
													onClick={() => openFullScreen(image.url)}
													className="imageZoom"
													style={{
														margin: `${senderId === prevId ? '5px' : '2px 5px 5px'}`,
													}}
												/>
												<br />
											</>
										);
									}
								})}

								{/* <p className="msg-time tickmark">{renderTickMark()}</p> */}
							</div>
							<div className="normal-msg">
								{/* Link */}
								{isLink ? (
									<a
										href={msg}
										target="_blank"
										rel="noopener noreferrer"
										className="link"
									>
										{msg}
									</a>
								) : (
									// Normal text

									<>
										{/* Normal text */}
										<p className="text">{formatMessage()}</p>
									</>
								)}
								<div className="tools">
									<p className="msg-time">{formatMessageTime()}</p>
									{renderFlagTooltip()}

									{/* {sender ? (
									<p className="msg-time tickmark">{renderTickMark()}</p>
								) : (
									<p className="msg-time tickmark"></p>
								)} */}
								</div>
							</div>
						</div>
					) : (
						// Text (link/normal) message
						<div className="normal-msg">
							{/* Link */}
							{isLink ? (
								<a
									href={msg}
									target="_blank"
									rel="noopener noreferrer"
									className="link"
								>
									{msg}
								</a>
							) : (
								// Normal text

								<>
									{/* Normal text */}
									<p
										className="text"
										onClick={() => {
											console.log(msgId);
										}}
									>
										{formatMessage()}
									</p>
								</>
							)}
							<div className="tools">
								<p className="msg-time">{formatMessageTime(time)}</p>

								{renderFlagTooltip()}

								{/* {sender ? (
								<p className="msg-time tickmark">{renderTickMark()}</p>
							) : (
								<p className="msg-time tickmark"></p>
							)} */}
							</div>
						</div>
					)}

					{showDropdown || forwardCheckbox ? null : (
						<div
							className="caret"
							onClick={event => handleCaretClick(event, msgId)}
							style={{ lineHeight: '5px', cursor: 'pointer', fontSize: '10px' }}
						>
							<DownOutlined />
						</div>
					)}

					{/* Dropdown */}
					{showDropdown && activeDropdownMsgId == msgId && (
						<div
							className={`dropdown ${sender ? 'dropdown-left' : 'dropdown-right'} ${
								isLastMessage() ? 'dropdown-up' : ''
							}`}
						>
							<ul>
								{msg != '🚫 This message was deleted.' && (
									<li
										onClick={() => {
											replyToMessage(msgId);
											setShowDropdown(false);
										}}
									>
										Reply
									</li>
								)}
								{msg != '🚫 This message was deleted.' && (
									<li onClick={markAsRedFlag}>
										{isRedFlagged ? 'Remove Red Flag' : 'Mark as Red Flag'}
									</li>
								)}
								<li
									onClick={() => {
										setForwardCheckbox(true);
										handleMsgSelect(
											msgId,
											forwardedMsgId,
											sender,
											isRedFlag,
											isForwarded,
											msg
										);
										setShowDropdown(false);
									}}
								>
									Select
								</li>
								<li
									onClick={() => {
										setShowDropdown(false);
										setReadByModel(true);
									}}
								>
									Read By
								</li>
							</ul>
						</div>
					)}
				</div>

				<div>
					<Modal
						open={readByModel}
						onCancel={() => setReadByModel(false)}
						footer={null}
						closable={true}
						className="delivery-status-modal readby-modal"
						centered
						style={{ backgroundColor: 'black', color: 'white' }}
					>
						{/* Display Read By Users */}
						<div className="status-group">
							<h3>Read By</h3>
							{readByArray.length > 0 ? (
								readByArray.map(usersArr => {
									if (usersArr.user._id !== user._id) {
										return (
											<div className="status-item" key={usersArr.user.username}>
												<div className="status-data">
													<p>{usersArr.user.username}</p>
													<p className="status-icon">
														<BsCheckAll />
													</p>
												</div>
												{usersArr.timestamp && (
													<div className="status-info">
														<p>
															Time:-
															{new Date(usersArr.timestamp).toLocaleString([], {
																hour: '2-digit',
																minute: '2-digit',
																hour12: true,
															})}
														</p>
														<p>
															, Date:-
															{new Date(usersArr.timestamp).toLocaleDateString()}
														</p>
													</div>
												)}
												<hr />
											</div>
										);
									}
									if (readByArray.length == 1 && usersArr.user._id == user._id) {
										return <p>No users have read the message yet.</p>;
									}
								})
							) : (
								<p>No users have read the message yet.</p>
							)}
						</div>
						<div className="status-group">
							<h3
								onClick={() => {
									console.log('usersOfParticularGroup,', usersOfParticularGroup);
								}}
							>
								UnRead By
							</h3>
							{readByArray.length > 0 ? (
								usersOfParticularGroup
									.filter(
										item2 =>
											!readByArray.some(item1 => item1.user.name === item2.user.name)
									)
									.map(filteredUser => (
										<div key={filteredUser.user.name}>
											{/* Render your filtered users */}
											{filteredUser.user.name}
											{/* Other user properties can be displayed here */}
										</div>
									))
							) : (
								<p>No users have read the message yet.</p>
							)}
						</div>
					</Modal>
				</div>
				{/* Fullscreen modal */}
				<Modal
					open={fullscreenVisible}
					footer={null}
					onCancel={closeFullScreen}
					closable={false}
					width="auto"
					className="fullscreen-modal"
					centered
				>
					<Tooltip title="Click here to download" placement="right">
						<a
							href={selectedImage}
							style={{ textDecoration: 'none', color: 'black' }}
						>
							<FaDownload size={20} style={{ cursor: 'pointer' }} />
						</a>
					</Tooltip>

					<div
						className="fullscreen-image-container"
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '60vh',
							width: '60vh',
							margin: '0 auto',
						}}
					>
						<Image
							src={selectedImage}
							preview={false}
							centered
							alt="Fullscreen Image"
							style={{ maxHeight: '80%', maxWidth: '80%', objectFit: 'contain' }}
						/>
					</div>
				</Modal>
				<Modal
					title="Remove Red Flag"
					visible={showDeliveryStatusModal}
					onCancel={() => setShowDeliveryStatusModal(false)}
					footer={null}
					centered
				>
					{/* ... your JSX for displaying delivery status ... */}
					{/* Add input field for the remark */}
					<div>
						<label htmlFor="remarkInput">Remark:</label>
						<input
							id="remarkInput"
							type="text"
							value={remarkInput}
							onChange={e => setRemarkInput(e.target.value)}
						/>
					</div>

					{/* Add the Ant Design Button component for the styled submit button */}
					<div style={{ marginTop: '16px' }}>
						<Button type="primary" onClick={handleRemarkSubmission}>
							Submit
						</Button>
					</div>
				</Modal>
			</div>
		</div>
	);
}

export default Message;
